export default {
	data() {
		return 	{
			confirmQBOPushModal: {
				visible: false,
				executeFunction: "",
				promiseResolveFunction: "",
				isUpdate: false
			}
		}
	},
	methods: {
		openQboConfirmModal(executeFunction,promiseResolveFunction,isUpdate) {
			this.confirmQBOPushModal.visible = true
			this.confirmQBOPushModal.executeFunction = executeFunction
			this.confirmQBOPushModal.promiseResolveFunction = promiseResolveFunction
		},
		qboPushConfirmed() {
			this.qboPushCompleted(true)
		},
		qboPushRejected() {
			this.qboPushCompleted(false)
		},
		qboPushCompleted(confirmed) {
			this.confirmQBOPushModal.visible = false

			let executeFunction = this.confirmQBOPushModal.executeFunction

			if (this.confirmQBOPushModal.promiseResolveFunction) {
				let promiseResolveFunction = this.confirmQBOPushModal.promiseResolveFunction
				
				this[executeFunction](confirmed).then(response => {
					this[promiseResolveFunction](response)
				})
			}
			else
				this[executeFunction](confirmed)
		}
	}
}